import { connect } from 'react-redux'
import * as TackIntervalSelectionActions from '../stores/tack_interval_selections/actions';
import TackIntervalSelectionComponent from '../components/tack_interval_selection';

const mapStateToProps = (state, ownProps) => {
  return {
    word: state.default.word,
    tackIntervalSelection: state.default.tackIntervalSelection,
    tackNotificationDetails: state.default.tackNotificationDetails,
    params: ownProps.match.params
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onMakeTackIntervalSelection: (tackSlug, tackIntervalSelectionMask) => {
      dispatch(TackIntervalSelectionActions.select(tackSlug, tackIntervalSelectionMask));
    },
    onResetTackIntervalSelection: () => {
      dispatch(TackIntervalSelectionActions.reset());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TackIntervalSelectionComponent);



// WEBPACK FOOTER //
// ./src/containers/tack_interval_selection.js